import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import ThemeToggleButton from './ThemeToggleButton';
import { resolveLogoFullId } from '../../lib/platformLogo';

const FILES_BASE = process.env.REACT_APP_BACKEND_URL;

const NAV_LINKS = [
  { href: '#features', label: 'الميزات' },
  { href: '#showcase', label: 'جولة في المنصة' },
  { href: '#how-it-works', label: 'كيف تعمل؟' },
  { href: '#testimonials', label: 'آراء العملاء' },
  { href: '#faq', label: 'الأسئلة' },
];

const VenuesNavLink = ({ className = '', onClick }) => (
  <button
    onClick={onClick}
    className={`text-sm font-medium text-slate-300 transition-colors hover:text-white ${className}`}
    data-testid="landing-nav-venues"
  >
    حجز الملاعب
  </button>
);

export const LandingNavbar = ({ platformSettings, scrolled, navigate, theme, onToggleTheme }) => {
  const [open, setOpen] = useState(false);
  const logoFileId = resolveLogoFullId(platformSettings, theme);
  const fullLogoUrl = logoFileId ? `${FILES_BASE}/api/files/${logoFileId}` : null;
  const goToVenues = () => navigate('/venues');

  return (
    <nav
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${scrolled ? 'border-b border-teal-900/30 bg-[#0A192F]/85 backdrop-blur-xl' : 'border-b border-transparent bg-transparent'}`}
      data-testid="landing-navbar"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-4">
        <div className="flex items-center" data-testid="landing-navbar-logo">
          {fullLogoUrl ? (
            <img src={fullLogoUrl} alt="تسيار" className="h-9 w-auto object-contain drop-shadow-[0_1px_6px_rgba(255,255,255,0.25)]" />
          ) : (
            <span className="font-display text-2xl font-black tracking-tight">
              <span className="text-white">تس</span><span className="text-teal-400">يار</span>
            </span>
          )}
        </div>

        <div className="hidden items-center gap-8 md:flex">
          {NAV_LINKS.map((l) => (
            <a key={l.href} href={l.href} className="text-sm font-medium text-slate-300 transition-colors hover:text-white" data-testid={`landing-nav-${l.href.slice(1)}`}>
              {l.label}
            </a>
          ))}
          <button onClick={() => navigate('/coaches')} className="text-sm font-medium text-slate-300 transition-colors hover:text-white" data-testid="landing-nav-coaches">
            المدربون
          </button>
          <VenuesNavLink onClick={goToVenues} />
        </div>

        <div className="hidden items-center gap-4 md:flex">
          {onToggleTheme && <ThemeToggleButton theme={theme} onToggle={onToggleTheme} />}
          <button onClick={() => navigate('/login')} className="text-sm font-semibold text-slate-300 transition-colors hover:text-white" data-testid="landing-login-btn">
            تسجيل الدخول
          </button>
          <button
            onClick={() => navigate('/register')}
            className="rounded-full bg-gradient-to-l from-orange-500 to-orange-400 px-6 py-2.5 text-sm font-bold text-white shadow-[0_0_15px_rgba(245,76,7,0.4)] transition-all hover:shadow-[0_0_22px_rgba(245,76,7,0.6)]"
            data-testid="landing-cta-nav-btn"
          >
            ابدأ مجانًا
          </button>
        </div>

        <div className="flex items-center gap-2 md:hidden">
          {onToggleTheme && <ThemeToggleButton theme={theme} onToggle={onToggleTheme} />}
          <button className="text-white" onClick={() => setOpen((o) => !o)} data-testid="landing-mobile-menu-btn">
            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-teal-900/30 bg-[#0A192F] px-5 py-4 md:hidden" data-testid="landing-mobile-menu">
          <div className="flex flex-col gap-4">
            {NAV_LINKS.map((l) => (
              <a key={l.href} href={l.href} onClick={() => setOpen(false)} className="text-sm font-medium text-slate-300 hover:text-white">
                {l.label}
              </a>
            ))}
            <button onClick={() => { setOpen(false); navigate('/coaches'); }} className="text-start text-sm font-medium text-slate-300 hover:text-white" data-testid="landing-mobile-nav-coaches">
              المدربون
            </button>
            <VenuesNavLink className="self-start" onClick={() => { setOpen(false); goToVenues(); }} />
            <button onClick={() => navigate('/login')} className="text-start text-sm font-semibold text-slate-300 hover:text-white" data-testid="landing-mobile-login-btn">
              تسجيل الدخول
            </button>
            <button onClick={() => navigate('/register')} className="mt-1 rounded-full bg-gradient-to-l from-orange-500 to-orange-400 px-6 py-2.5 text-sm font-bold text-white" data-testid="landing-mobile-cta-btn">
              ابدأ مجانًا
            </button>
          </div>
        </div>
      )}
    </nav>
  );
};

export default LandingNavbar;
